import { useEffect } from "react";
import { useLocation } from 'react-router';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";

gsap.registerPlugin(ScrollTrigger);

export default function useScrollTriggerRefresh() {
  const location = useLocation();

  useEffect(() => {
    // Timeout pour laisser le DOM se re-render
    const t = setTimeout(() => {
      ScrollTrigger.refresh();

      // On s'assure qu'on reste bien en haut de la fenêtre
      window.scrollTo(0, 0);
    }, 100);

    return () => clearTimeout(t);
  }, [location]);
}
